import {
  Container,
  Time,
  Destination,
  Code,
  City,
  TimesWrapper,
} from './Location.style';

const Location = ({
  location,
  direction,
  locationTime: {
    [direction]: { actual, scheduled, estimated },
  },
  isSameDate,
}) => {
  const isEstimated = estimated && estimated !== scheduled;
  const isActual = actual && actual !== scheduled;

  return (
    <Container>
      <TimesWrapper>
        <Time variant="p" actual={isEstimated || isActual ? 'true' : ''}>
          {`${scheduled}${
            direction === 'arrival' && !isEstimated && !isActual && !isSameDate
              ? ' (+1)'
              : ''
          }`}
        </Time>
        <Time variant="p" sx={{ whiteSpace: 'nowrap' }}>
          {isActual ? actual : isEstimated ? estimated : ''}
          {(isActual || isEstimated) &&
            isSameDate !== undefined &&
            !isSameDate &&
            ' (+1)'}
        </Time>
      </TimesWrapper>
      <Destination>
        <City variant="p">{location?.city || location?.city_name}</City>
        <Code variant="button">{location?.fs || location?.airport_code}</Code>
      </Destination>
    </Container>
  );
};

export default Location;
